import axios from 'axios';
import withDecrypt from '../../src/withDecrypt';
// import handler from '../../pages/api/redis-limit';
// import handler from '../../pages/api/rate-limiter';

async function fetchAPI(query, accessToken) {
  // await handler()
  return axios({
    method: 'post',
    url: process.env.NEXT_PUBLIC_API_URL,
    data: {
      query,
    },
    headers: { accesstoken: accessToken },
  })
    .then(resp => withDecrypt(resp.data))
    .catch(err => {
      console.log(err);
    });
}

export default async function getWatchlist(accessToken) {
  const data = await fetchAPI(
    `
    {
      getWatchlist {
        name
        description
        notes
        columns
        isSystemDefault
        tickers
      }
    }
    `, accessToken
  )
  return data
}

